import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransportRoutingModule } from './transport-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule, CollapseModule, TabsModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RouteFeeStructureComponent } from './route-fee-structure/route-fee-structure.component';
import { RouteDetailsComponent } from './route-details/route-details.component';
import { LocationComponent } from './location/location.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { StudentVehicleWiseComponent } from './student-vehicle-wise/student-vehicle-wise.component';
import { StudentTransportOptReportComponent } from './student-transport-opt-report/student-transport-opt-report.component';
import { PrintStudentTransportOptReportComponent } from './print-student-transport-opt-report/print-student-transport-opt-report.component';
import { PrintStudentVehicleWiseComponent } from './print-student-vehicle-wise/print-student-vehicle-wise.component';
import { TransportPaymentComponent } from './transport-payment/transport-payment.component';


@NgModule({
  declarations: [RouteFeeStructureComponent, RouteDetailsComponent, LocationComponent, VehicleDetailsComponent, StudentVehicleWiseComponent, StudentTransportOptReportComponent, PrintStudentTransportOptReportComponent, PrintStudentVehicleWiseComponent,TransportPaymentComponent],
  imports: [
    CommonModule,
    TransportRoutingModule,
    AdminModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot()
  ]
})
export class TransportModule { }
